export default __webpack_public_path__ + "static/media/blur-leaf.c96c4761.png";